import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=a94716cc&scoped=true"
import script from "./DataField.vue?vue&type=script&lang=js"
export * from "./DataField.vue?vue&type=script&lang=js"
import style0 from "./DataField.vue?vue&type=style&index=0&id=a94716cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94716cc",
  null
  
)

export default component.exports